<template>
  <div class="container">
    <a-button
      @click="$router.back()"
      style="border-radius: 20px; background-image: linear-gradient(to right, #1D2671 , #830051); color: white;margin-bottom: 10px;"
      ><LeftOutlined /> Back</a-button
    >
    <div class="doctor-prescription  p-sm-5">
      <h1 class="title mb-4">RESEP DOKTER</h1>
      <!-- Added form for detailed information -->
      <a-form :model="profileData" class="p-1 p-sm-5">
        <div class="row form-item">
          <div class="col-12 col-sm-2 text-left text-sm-right"><label>Nama Dokter :</label></div>
          <div class="col-12 col-sm-10"><a-input v-model:value="profileData.namaDokter" /></div>
        </div>
        <div class="row form-item">
          <div class="col-12 col-sm-2 text-left text-sm-right"><label>Jenis Terapi :</label></div>
          <div class="col-12 col-sm-10"><a-input v-model:value="profileData.jenisTerapi" /></div>
        </div>
        <div v-if="isNewProgram" class="row form-item text-left">
          <div class="col-12 col-sm-2 text-right">
            <label class="required-label">Provinsi Farmasi :</label>
          </div>
          <div class="col-12 col-sm-10 text-left">
            <a-select
              v-model:value="selectedProvince"
              show-search
              allow-clear
              placeholder="Pilih provinsi"
              class="pharmacy-select"
              style="width: 100%"
              :filter-option="filterOption"
              :loading="loadingProvince"
              @change="handleProvinceChange"
            >
              <a-select-option
                v-for="item in provinces"
                :key="getOptionValue(item)"
                :value="getOptionValue(item)"
              >
                {{ getOptionLabel(item) }}
              </a-select-option>
            </a-select>
          </div>
        </div>
        <div v-if="isNewProgram" class="row form-item text-left">
          <div class="col-12 col-sm-2 text-left text-sm-right">
            <label class="text-left required-label">Kota Farmasi :</label>
          </div>
          <div class="col-12 col-sm-10 text-left">
            <a-select
              v-model:value="selectedCity"
              show-search
              allow-clear
              placeholder="Pilih kota"
              class="pharmacy-select"
              style="width: 100%"
              :disabled="!selectedProvince"
              :filter-option="filterOption"
              :loading="loadingCity"
              @change="handleCityChange"
            >
              <a-select-option
                v-for="item in cities"
                :key="getOptionValue(item)"
                :value="getOptionValue(item)"
              >
                {{ getOptionLabel(item) }}
              </a-select-option>
            </a-select>
          </div>
        </div>
        <div v-if="isNewProgram" class="row form-item text-left">
          <div class="col-12 col-sm-2 text-left text-sm-right">
            <label class="text-left required-label">Farmasi :</label>
          </div>
          <div class="col-12 col-sm-10 text-left">
            <a-select
              v-model:value="selectedPharmacy"
              show-search
              allow-clear
              placeholder="Pilih farmasi"
              class="pharmacy-select"
              style="width: 100%"
              :disabled="!selectedCity"
              :filter-option="filterOption"
              :loading="loadingPharmacy"
            >
              <a-select-option
                v-for="item in pharmacies"
                :key="getOptionValue(item)"
                :value="getOptionValue(item)"
              >
                {{ getOptionLabel(item) }}
              </a-select-option>
            </a-select>
          </div>
        </div>
        <div class="row form-item mt-4">
          <div class="col-12 col-sm-2 text-left text-sm-right">
            <label>Unggah Resep Dokter :</label>
          </div>
          <div class="col-12 col-sm-10">
            <p class="text-left m-0 mb-3">
              Pastikan anda mengunggah foto resep secara lengkap dan jelas
            </p>
            <a-upload
              class="upload-section"
              list-type="picture-card"
              :file-list="fileList"
              @change="handleChange"
              @preview="handlePreview"
              :before-upload="() => false"
              :max-count="1"
            >
              <div v-if="!fileList.length">
                <a-icon type="camera" />
                <div>Unggah Foto</div>
              </div>
            </a-upload>
            <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel" centered>
              <img
                alt="example"
                style="width: 100%;margin-top: 30px; object-fit: cover;"
                :src="previewImage"
              />
            </a-modal>
          </div>
        </div>
        <div class="row form-item mt-4" v-if="profileData.jenisTerapi === 'ENHERTU'">
          <div class="col-12 col-sm-2 text-left text-sm-right">
            <label>Unggah Berat Badan :</label>
          </div>
          <div class="col-12 col-sm-10">
            <p class="text-left m-0 mb-3">
              Pastikan anda mengunggah foto berat badan secara lengkap dan jelas
            </p>
            <a-upload
              class="upload-section"
              list-type="picture-card"
              :file-list="fileListWeight"
              @change="handleChangeWeight"
              :before-upload="() => false"
            >
              <div>
                <a-icon type="camera" />
                <div>Unggah Foto</div>
              </div>
            </a-upload>
          </div>
        </div>
        <a-button type="primary" :disabled="isSubmitDisabled" @click="handleSubmit">KIRIM</a-button>
      </a-form>
    </div>
  </div>
</template>

<script>
import { computed, ref, onMounted } from 'vue'
import { Upload, Form, Input, Button, message } from 'ant-design-vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import {
  getFarmasi,
  getFarmasiCity,
  getFarmasiProvince,
  getPatientProgram,
  uploadResepImage,
  uploadResepResult,
  uploadWeightImage,
} from '../../../services/axios/pulih'
import { LeftOutlined } from '@ant-design/icons-vue'
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })
}
export default {
  components: {
    'a-upload': Upload,
    'a-form': Form,
    'a-input': Input,
    'a-button': Button,
    LeftOutlined,
  },
  setup() {
    const fileList = ref([])
    const fileListWeight = ref([])
    const store = useStore()
    const provinces = ref([])
    const cities = ref([])
    const pharmacies = ref([])
    const selectedProvince = ref()
    const selectedCity = ref()
    const selectedPharmacy = ref()
    const isNewProgram = ref(false)
    const loadingProvince = ref(false)
    const loadingCity = ref(false)
    const loadingPharmacy = ref(false)
    const profileData = ref({
      namaDokter: 'John Doe',
      jenisTerapi: 'LYNPARZA',
      email: 'johndoe@example.com',
    })
    const router = useRouter()
    const handleChange = ({ fileList: newFileList }) => {
      fileList.value = newFileList
    }
    const handleChangeWeight = ({ fileList: newFileList }) => {
      fileListWeight.value = newFileList
    }
    const dataProgramPatient = ref({
      programs: [],
    })
    const isPharmacySelectionComplete = computed(
      () =>
        !isNewProgram.value ||
        Boolean(selectedProvince.value && selectedCity.value && selectedPharmacy.value),
    )
    const isSubmitDisabled = computed(() => !isPharmacySelectionComplete.value)
    const getOptionValue = item => {
      if (!item || typeof item !== 'object') {
        return item
      }
      return (
        item.id ||
        item.value ||
        item.pharmacyId ||
        item.pharmacy_id ||
        item.provinceId ||
        item.province_id ||
        item.cityId ||
        item.city_id ||
        item.name ||
        item.pharmacyName ||
        item.pharmacy_name ||
        item.provinceName ||
        item.province_name ||
        item.cityName ||
        item.city_name ||
        item.city ||
        item.province
      )
    }
    const getOptionLabel = item => {
      if (!item || typeof item !== 'object') {
        return item
      }
      return (
        item.name ||
        item.label ||
        item.pharmacyName ||
        item.pharmacy_name ||
        item.provinceName ||
        item.province_name ||
        item.cityName ||
        item.city_name ||
        item.city ||
        item.province ||
        item.fullname ||
        item.id ||
        item.value
      )
    }
    const getListData = data => {
      if (Array.isArray(data)) {
        return data
      }
      if (data && Array.isArray(data.data)) {
        return data.data
      }
      return []
    }
    const filterOption = (input, option) => {
      const children = option.children || []
      const label = children[0]?.children || children[0] || option.value
      return String(label)
        .toLowerCase()
        .includes(input.toLowerCase())
    }
    const fetchProvinces = async () => {
      loadingProvince.value = true
      try {
        const response = await getFarmasiProvince()
        provinces.value = getListData(response.data)
      } finally {
        loadingProvince.value = false
      }
    }
    const handleProvinceChange = async value => {
      selectedProvince.value = value
      selectedCity.value = undefined
      selectedPharmacy.value = undefined
      cities.value = []
      pharmacies.value = []
      if (!value) {
        return
      }
      loadingCity.value = true
      try {
        const response = await getFarmasiCity(value)
        cities.value = getListData(response.data)
      } finally {
        loadingCity.value = false
      }
    }
    const handleCityChange = async value => {
      selectedCity.value = value
      selectedPharmacy.value = undefined
      pharmacies.value = []
      if (!value) {
        return
      }
      loadingPharmacy.value = true
      try {
        const response = await getFarmasi(value)
        pharmacies.value = getListData(response.data)
      } finally {
        loadingPharmacy.value = false
      }
    }
    const handleSubmit = async () => {
      // console.log('Submitting files:', fileList.value)
      if (fileList.value.length === 0) {
        message.error('Mohon unggah resep dokter.')
        console.error('No file selected for upload.')
        return
      }
      if (isNewProgram.value && !selectedProvince.value) {
        message.error('Mohon pilih provinsi farmasi.')
        return
      }
      if (isNewProgram.value && !selectedCity.value) {
        message.error('Mohon pilih kota farmasi.')
        return
      }
      if (isNewProgram.value && !selectedPharmacy.value) {
        message.error('Mohon pilih farmasi.')
        return
      }

      const file = fileList.value[0].originFileObj // Ambil file yang akan diupload

      try {
        const res = await uploadResepImage('Lab Test Result', file)
        // console.log('Upload response:', res)
        let fileWeight = ''
        let resWeight = ''
        if (fileListWeight.value.length) {
          fileWeight = fileListWeight.value[0].originFileObj // Ambil file yang akan diupload
          const res = await uploadWeightImage('Lab Test Result', fileWeight)
          resWeight = res
        }
        const response = await uploadResepResult(
          dataProgramPatient.value.programs[0].id,
          res.data,
          resWeight ? resWeight.data : '',
          isNewProgram.value ? selectedPharmacy.value : '',
        )
        // console.log(response, 'inihasiltesLabTypeId')
        if (response && response.data) {
          store.dispatch('updateAttribute', {
            attribute: 'unggahResepDokter',
            value: 'unggahResepDokter',
          })
          router.push(`/survey`)
        } else {
          message.error('Gagal mengirim resep dokter.')
        }
        // Redirect atau logika tambahan setelah upload sukses
      } catch (error) {
        console.error('Upload failed:', error)
      }
    }
    onMounted(async () => {
      const userData = JSON.parse(localStorage.getItem('userData'))
      const res = await getPatientProgram(userData.user.code)
      dataProgramPatient.value = res
      const program = dataProgramPatient.value.programs[0]
      isNewProgram.value = program.prevProgram === null
      profileData.value.namaDokter = res.programs[0].doctor.fullname
      profileData.value.jenisTerapi = res.programs[0].programType.name
      // console.log(dataProgramPatient.value.programs[0].programType.name, 'inidataprogramdiresep')
      // console.log(dataProgramPatient.value.programs[0], 'inidataprogram')
      if (isNewProgram.value) {
        await fetchProvinces()
      }
    })
    const previewVisible = ref(false)
    const previewImage = ref('')
    const handleCancel = () => {
      previewVisible.value = false
    }
    const handlePreview = async file => {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj)
      }
      previewImage.value = file.url || file.preview
      previewVisible.value = true
    }

    return {
      previewVisible,
      previewImage,
      handleCancel,
      handlePreview,
      handleChangeWeight,
      fileListWeight,
      fileList,
      handleChange,
      handleSubmit,
      profileData,
      provinces,
      cities,
      pharmacies,
      selectedProvince,
      selectedCity,
      selectedPharmacy,
      isNewProgram,
      isSubmitDisabled,
      loadingProvince,
      loadingCity,
      loadingPharmacy,
      getOptionValue,
      getOptionLabel,
      filterOption,
      handleProvinceChange,
      handleCityChange,
    }
  },
}
</script>

<style scoped>
:global(.ant-upload-list-item-info::before) {
  left: 0 !important;
}
.doctor-prescription {
  /* max-width: 400px; */
  margin: auto;
  padding: 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  border-radius: 24px;
  background: white;
  text-align: center;
}

.doctor-info div {
  margin-bottom: 10px;
  text-align: left;
}

.upload-section {
  /* margin: 20px 0; */
}

.title {
  color: #333;
}

.text-left text-sm-right {
  text-align: left;
  padding-right: 15px;
}

.form-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.pharmacy-select {
  text-align: left;
}

.required-label::after {
  color: #ff4d4f;
  content: ' *';
}

:global(.pharmacy-select .ant-select-selector),
:global(.pharmacy-select .ant-select-selection-item),
:global(.pharmacy-select .ant-select-selection-placeholder),
:global(.pharmacy-select .ant-select-selection-search-input) {
  text-align: left !important;
}

.col-12 {
  flex: 1;
}

.col-sm-10 {
  flex: 0 0 83.33333%;
  max-width: 83.33333%;
}

.col-12 col-sm-2 {
  flex: 0 0 16.66667%;
  max-width: 16.66667%;
}
</style>
